// store.js
import { configureStore } from "@reduxjs/toolkit";

// Reducers
import { authReducer } from "../reducers/authReducer";
import { authRolesReducer } from "../reducers/authRolesReducer";
import { hotelIDReducer } from "../reducers/hotelIDReducer";
import { dataMembershipReducer } from "../reducers/dataMembershipReducer";
import { dataSimpleReducer } from "../reducers/dataSimpleReducer";
import { PDFExportReducer } from "../reducers/PDFExportReducer";
import { globalReportFiltersReducer } from "../reducers/globalReportFiltersReducer";

// To Remove:
import { preferencesReducer } from "../reducers/preferencesReducer";
import { indicatorReducer } from "../reducers/indicatorReducer";
import { dataVouchersDetailsReducer } from "../reducers/dataVouchersDetailsReducer";
import { settingsReducer } from "../reducers/settingsReducer";

// RTK
import { commissionsApi } from "../features/commissions/commissionsApi";
import commissionsReducer from "../features/commissions/dataCommissionsSlice";

import { bookingsApi } from "../features/bookings/bookingsApi";
import bookingsReducer from "../features/bookings/dataBookingsSlice";

import { searchesApi } from "../features/searches/searchesApi";
import searchesReducer from "../features/searches/dataSearchesSlice";

import { targetsApi } from "../features/targets/targetsApi";
import targetsReducer from "../features/targets/dataTargetsSlice";

import { aroInsightsApi } from "../features/aroInsightsApi/aroInsightsApi";
import aroInsightsReducer from "../features/aroInsightsApi/dataAroInsightsSlice";

import { hotelsApi } from "../features/hotels/hotelsApi";

// Types
import { PDFExportTypes } from "../types/PDFExportTypes";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        authRoles: authRolesReducer,
        preferences: preferencesReducer,
        indicator: indicatorReducer,
        hotelID: hotelIDReducer,
        dataBookings: bookingsReducer,
        [bookingsApi.reducerPath]: bookingsApi.reducer,
        dataMembership: dataMembershipReducer,
        dataVouchersDetails: dataVouchersDetailsReducer,
        dataSimple: dataSimpleReducer,
        dataSearches: searchesReducer,
        [searchesApi.reducerPath]: searchesApi.reducer,
        dataCommission: commissionsReducer,
        [commissionsApi.reducerPath]: commissionsApi.reducer,
        dataTargets: targetsReducer,
        [targetsApi.reducerPath]: targetsApi.reducer,
        settings: settingsReducer,
        PDFExport: PDFExportReducer,
        globalReportFilters: globalReportFiltersReducer,
        dataAroInsights: aroInsightsReducer,
        [aroInsightsApi.reducerPath]: aroInsightsApi.reducer,
        [hotelsApi.reducerPath]: hotelsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [PDFExportTypes.loadOne], // TODO: eventually remake how the PDF uses the storage, it should use in in this way, but it works
                ignoredPaths: ["PDFExport.data"],
                warnAfter: 128,
            },
            immutableCheck: {
                warnAfter: 128,
            },
        }).concat(
            commissionsApi.middleware,
            bookingsApi.middleware,
            searchesApi.middleware,
            targetsApi.middleware,
            aroInsightsApi.middleware,
            hotelsApi.middleware,
        ),
    devTools: process.env.NODE_ENV !== "production",
});
